import React from "react";
import { Container, Table } from "react-bootstrap";
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import "./ItemList.scss";
import messages from '../../assets/i18n';
import { ErrorMessageList, ItemCell, CheckBox, ButtonStandard, SomatoriasConciliacao } from "../../components";

function ItemList(props) {
  
  const lang = useSelector(state => state.language.name)
  
  const { titleTable, header, listTable, isLoading, error, hasMore, handleHasMore, hasMoreIsLoading, isEmpty, somatoriasConciliacao } = props

  return (
    <Container className="text-center">
      {
        titleTable && 
          <div className="extra-rounded-top bg-color-primary py-2 mb-1">
            <span className="text-4 font-weight-bolder">
              {titleTable}
            </span>
          </div>
      }
			<Table id="itemGrid" responsive className="border-white full-width">
				<thead>
					<tr className="mt-2">
						{ 
							header && header.map( value => {
                let headerCol = value;
                if (typeof value !== 'string' && value && value.checkbox) {
                  headerCol = <CheckBox 
                    clicked={ value.checkbox.arrChecked && value.checkbox.arrChecked.length > 0 ? value.checkbox.arrChecked.length >= listTable.length : false } 
                    onClick={ value.checkbox.handleAllArrChecked }
                  />
                }
                
                return <th 
                      className="bg-color-tertiary m-2 text-2 font-weight-light item-list-header-border" 
                      key={value}>{headerCol}
                    </th>;
              })
            }
          </tr>
        </thead>
        <tbody>
					{
						!error &&
            !isLoading &&
            listTable &&
            listTable.map((objectRow, indexRow) => {
              return (
              	<tr key={indexRow}>
                	{
                  	Object.keys(objectRow).map((key) => {
                      return (
                        <ItemCell 
                          key={key}
                          valueCol={objectRow[key]} 
                        />
                      )
										})
                  }
                </tr>
              );
            })
					}
          {
            !error &&
            !isLoading &&
            hasMore && (
              <tr>
                <td colSpan={header ? header.length : 1} className="text-3 text-color-primary font-weight-bolder my-3 pt-1">
                  <ButtonStandard
                    className="btn btn-secondary btn-sm btn-standard"
                    isLoading={hasMoreIsLoading}
                    text={messages[lang].loadMoreData}
                    onClick={handleHasMore}>
                  </ButtonStandard>
                </td>
              </tr>
              )}
          {
            somatoriasConciliacao
            ?
            <SomatoriasConciliacao
              somatoriasConciliacao={somatoriasConciliacao}
            />
            :
            null
          }

        </tbody>
      </Table>
      {
				error && (
          <ErrorMessageList errors={error} />
        )
			}
      {
				isLoading && (
          <div>
						<p className="text-3 text-color-primary my-0 pt-1">
							{messages[lang].loading}
            </p>
          </div>
        )
			}
      {
				!isLoading && isEmpty && (
          <div>
						<p className="text-3 text-color-primary my-0 pt-1">
              {messages[lang].noData}
            </p>
          </div>
        )
			}
      {
				!isLoading && !hasMore && !isEmpty && (
          <div>
						<p className="text-3 text-color-primary my-0 pt-1">
            {messages[lang].endOfResults}
            </p>
          </div>
        )
			}
    </Container>
  )
};

ItemList.propTypes = {
  titleTable: PropTypes.string, 
  header: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])).isRequired,
  listTable: PropTypes.arrayOf(PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]))).isRequired,
  isLoading: PropTypes.bool,
  isEmpty: PropTypes.bool,
  error: PropTypes.array,
  hasMore: PropTypes.bool,
  handleHasMore: PropTypes.func,
}

export default ItemList;